import type { DemoKey } from '../types';

export const mr: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'गणित · सांख्यिकी',
  'app.title': 'सांख्यिकी',
  'panel.experiment': 'दृश्य',
  'panel.params': 'पॅरामीटर',

  'exp.survey-explorer.title': 'सर्वेक्षण एक्सप्लोरर',
  'exp.survey-explorer.desc': 'स्तंभ निवडा; डेमो योग्य सारांश निवडतो.',
  'exp.distribution-sculptor.title': 'वितरण शिल्पकार',
  'exp.distribution-sculptor.desc': 'बिंदू ओढून पहा सांख्यिकी कशी प्रतिक्रिया देतात.',
  'exp.two-variable-lab.title': 'द्विचल प्रयोगशाळा',
  'exp.two-variable-lab.desc': 'विखुर, फिट आणि कारण-कार्याचा प्रश्न.',
  'exp.sampling-lab.title': 'नमुनेकरण प्रयोगशाळा',
  'exp.sampling-lab.desc': 'तंत्र आणि आकार नमुना सरासरीला कसे हलवतात.',
  'exp.probability-diagrams.title': 'प्रायिकता आकृत्या',
  'exp.probability-diagrams.desc': 'संयुक्त घटनांचे व्हेन व वृक्ष दृश्ये.',

  'type.qualitative-nominal.label': 'गुणात्मक · नामिक',
  'type.qualitative-nominal.def': 'क्रम नसलेल्या श्रेणी.',
  'type.qualitative-ordinal.label': 'गुणात्मक · क्रमिक',
  'type.qualitative-ordinal.def': 'अर्थपूर्ण क्रम असलेल्या श्रेणी.',
  'type.qualitative-multi.label': 'गुणात्मक · बहु-मूल्य',
  'type.qualitative-multi.def': 'प्रत्येक निरीक्षणाला अनेक टॅग असू शकतात.',
  'type.quantitative-discrete.label': 'संख्यात्मक · विविक्त',
  'type.quantitative-discrete.def': 'ठरावीक पावलांनी येणारे आकडे.',
  'type.quantitative-continuous.label': 'संख्यात्मक · संतत',
  'type.quantitative-continuous.def': 'संतत प्रमाणावर मोजलेले आकडे.',

  'column.name.label': 'विद्यार्थी नाव',
  'column.height_cm.label': 'उंची',
  'column.shoe_size_eu.label': 'बूट साइज (EU)',
  'column.study_hours.label': 'अभ्यास तास / आठवडा',
  'column.test_score.label': 'चाचणी गुण',
  'column.sports_played.label': 'खेळ',
  'column.eye_color.label': 'डोळ्यांचा रंग',
  'column.commute_min.label': 'प्रवास',
  'column.grade_year.label': 'इयत्ता',
  'column.homework_effort.label': 'गृहपाठ मेहनत',
  'column.ice-cream-sales.label': 'आइस्क्रीम विक्री',
  'column.drownings.label': 'बुडण्याच्या घटना',
  'column.month.label': 'महिना',
  'column.storks.label': 'करकोचे',
  'column.births.label': 'जन्म',
  'column.country_area_km2.label': 'देशाचे क्षेत्रफळ',
  'column.sleep_hours.label': 'झोपेचे तास',
  'column.reaction_ms.label': 'प्रतिक्रिया वेळ',

  'dataset.master-survey.label': 'वर्ग सर्वेक्षण',
  'dataset.master-survey.desc': '30 सिम्युलेटेड विद्यार्थी.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'आइस्क्रीम विक्री वि. बुडणे',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'दोन्ही ऋतूनुसार वर-खाली होतात. बुडण्याने आइस्क्रीम विक्री होत नाही.',
  'dataset.spurious-storks-vs-births.label': 'करकोचे वि. जन्म',
  'dataset.spurious-storks-vs-births.desc':
    'मोठ्या देशांत अधिक करकोचे आणि अधिक जन्म. पक्षी कारण नाहीत.',
  'dataset.real-sleep-vs-reaction-time.label': 'झोप वि. प्रतिक्रिया वेळ',
  'dataset.real-sleep-vs-reaction-time.desc':
    'अधिक झोप, वेगवान प्रतिक्रिया. खरा ऋणात्मक सहसंबंध — आणि शक्य कारण.',

  'tag.football.label': 'फुटबॉल',
  'tag.basketball.label': 'बास्केटबॉल',
  'tag.volleyball.label': 'व्हॉलीबॉल',
  'tag.swimming.label': 'पोहणे',
  'tag.none.label': 'काही नाही',

  'population.gaussian.label': 'घंटा वक्र',
  'population.right-skewed.label': 'उजवीकडे झुकलेले',
  'population.bimodal.label': 'द्विशिखर (स्तरयुक्त)',
  'population.uniform.label': 'समान',

  'venn.dice-even-or-prime.label': 'फासा: सम किंवा मूळ',
  'venn.class-sports-2set.label': 'खेळ (2 संच)',
  'venn.class-sports-3set.label': 'खेळ (3 संच)',
  'venn.custom.label': 'सानुकूल',

  'tree.draw-without-replacement.label': 'बदलीशिवाय',
  'tree.custom.label': 'सानुकूल',
  'tree.coin.heads': 'छ',
  'tree.coin.tails': 'का',
  'tree.draw.start': 'पिशवी: 2 लाल, 3 निळ्या',
  'tree.draw.red': 'लाल',
  'tree.draw.blue': 'निळा',
  'tree.custom.start': 'सुरू',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'हिस्टोग्राम',
  'card.cumulative': 'संचयी वारंवारता',
  'card.box': 'बॉक्स प्लॉट',
  'card.summary': '5-संख्या सारांश',
  'card.bar': 'बार चार्ट',
  'card.mode': 'बहुलक',
  'card.tag-frequency': 'टॅग वारंवारता',
  'card.mode-tag': 'शीर्ष टॅग',
  'card.empty-no-order': 'लागू नाही',
  'card.empty-multi': 'लागू नाही',
  'card.numberline': 'संख्यारेषा',
  'card.scatter': 'विखुर',
  'card.description': 'काय घडते',
  'card.population': 'लोकसंख्या',
  'card.sampling-distribution': 'नमुना सरासरी',
  'card.venn': 'व्हेन',
  'card.tree': 'वृक्ष',
  'card.probabilities': 'प्रायिकता',

  'param.dataset.label': 'डेटा संच',
  'param.column.label': 'स्तंभ',
  'param.bins.label': 'विभाग',
  'param.shape.label': 'प्रारंभिक आकार',
  'param.show-mean.label': 'सरासरी दाखवा',
  'param.show-median.label': 'मध्यिका दाखवा',
  'param.x-col.label': 'X स्तंभ',
  'param.y-col.label': 'Y स्तंभ',
  'param.show-regression.label': 'समाश्रयण रेषा',
  'param.show-residuals.label': 'अवशेष',
  'param.show-confounder.label': 'भ्रामक चर दाखवा',
  'param.population.label': 'लोकसंख्या',
  'param.technique.label': 'तंत्र',
  'param.sample-size.label': 'नमुना आकार',
  'param.stratum.label': 'स्तर',
  'param.bias.label': 'पक्षपात',
  'param.mode.label': 'मोड',
  'param.preset.label': 'प्रीसेट',
  'param.universe.label': 'विश्व आकार',
  'param.show-prob.label': 'प्रायिकता दाखवा',
  'param.treat-as-numeric.label': 'संख्यात्मक मानू',

  'stat.count': 'गणना',
  'stat.mean': 'सरासरी',
  'stat.median': 'मध्यिका',
  'stat.range': 'विस्तार',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'विचलित मूल्ये',
  'stat.r': 'पिअर्सन r',
  'stat.r2': 'r²',
  'stat.slope': 'उतार',
  'stat.intercept': 'अंतःछेद',
  'stat.n': 'n',
  'stat.population-mean': 'खरी सरासरी',
  'stat.latest-sample-mean': 'नमुना सरासरी',
  'stat.sample-mean-spread': 'नमुना सरासरी SD',
  'stat.sample-count': 'घेतलेले नमुने',
  'outlier.upper': 'वरचे विचलित',
  'outlier.lower': 'खालचे विचलित',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'पुनःनमुना',
  'btn.run-100': '100 नमुने घ्या',
  'btn.stop': 'थांबा',
  'btn.clear-history': 'इतिहास पुसून टाका',

  'explainer.no-order': 'क्रम नाही → संचयी नाही, बॉक्स नाही.',
  'explainer.multi-no-iqr': 'बहु-मूल्य → चतुर्थक / IQR अव्याख्यात.',
  'message.no-data': 'डेटा नाही.',
  'message.needs-quartiles': 'चतुर्थकांसाठी ≥4 बिंदू हवेत.',
  'message.x-zero-variance': 'X चे प्रसरण शून्य — रेषा बसवता येत नाही.',
  'message.n-too-small': 'n फार लहान.',
  'message.stratum-clamp': 'स्तरात मागितल्यापेक्षा कमी पंक्ती होत्या — सर्व वापरल्या.',
  'message.siblings-sum-to-one': 'भावंडांची बेरीज 1 हवी.',
};
